"use strict";

var _interopRequireDefault = require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _region = require("@/api/region");
var _pos = require("@/api/pos");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  props: {
    location: {
      type: Object,
      default: function _default() {}
    },
    width: {
      type: String,
      default: '768px'
    },
    height: {
      type: String,
      default: '500px'
    },
    left: {
      type: String,
      default: '768px'
    }
  },
  data: function data() {
    return {
      searchValue: '',
      // 地图搜索
      form: {
        longitude: '',
        latitude: '',
        address: '',
        location: '',
        city: '东莞市'
      },
      region: [],
      regionTree: [],
      searchArr: [],
      isSearch: false,
      timer: null,
      key: 'XUNBZ-5IUWX-3D54V-ZINAZ-Q5KJ7-55FRP'
    };
  },
  watch: {
    searchValue: {
      handler: function handler(val) {
        var _this = this;
        this.isSearch = true;
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(function () {
          _this.searchAddress(val);
          clearTimeout(_this.timer);
          _this.timer = null;
        }, 300);
      }
    },
    location: {
      handler: function handler(val) {
        for (var k in val) {
          this.form[k] = val[k] || '';
        }
        if (val.longitude) {
          // 点标注数据数组
          var geometries = [{
            id: 1,
            position: new window.TMap.LatLng(Number(val.latitude), Number(val.longitude))
          }];

          // 绘制地点标注
          this.markerLayer.updateGeometries(geometries);
        }
      },
      deep: true
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this2 = this;
      var that;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            (0, _region.getTree)({
              level: 2
            }).then(function (res) {
              if (!res.code) {
                res.data.map(function (item) {
                  item.children.map(function (item) {
                    delete item.children;
                  });
                });
                _this2.regionTree = res.data;
              }
            });
            window.addEventListener('click', function () {
              _this2.isSearch = false;
            });
            that = this;
            if (!this.script) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            this.script = document.createElement('script');
            this.script.type = 'text/javascript';
            this.script.src = "https://map.qq.com/api/gljs?v=1.exp&libraries=service&key=".concat(this.key);
            document.head.appendChild(this.script);
            this.script.onload = function () {
              window.initMap = that.initMap;
              that.$nextTick(function () {
                that.initMap();
              });
            };
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    // 地图
    initMap: function initMap() {
      var _this3 = this;
      // 搜索类
      this.searchEr = new window.TMap.service.Search({
        'pageSize': 10
      });
      // 地图主类
      this.map = new window.TMap.Map(this.$refs.map, {
        backgroundColor: '#f7f7f7',
        mapStyleId: 'style1',
        zoom: 12,
        mapTypeControlOptions: {
          mapTypeIds: []
        },
        showControl: false,
        draggableCursor: 'crosshair',
        draggingCursor: 'crosshair',
        center: new window.TMap.LatLng(this.location.latitude || 23.02067, this.location.longitude || 113.75179)
      });

      // 图层类
      this.markerLayer = new window.TMap.MultiMarker({
        map: this.map,
        geometries: []
      });
      // 地址逆解析
      this.geocoder = new window.TMap.service.Geocoder();
      var setMarker = function setMarker() {
        var latlng = new window.TMap.LatLng(_this3.form.latitude, _this3.form.longitude);
        _this3.markerLayer.setGeometries([]);
        var geometries = _this3.markerLayer.getGeometries();
        geometries.push({
          id: '-1',
          position: latlng
        });
        _this3.markerLayer.updateGeometries(geometries);
      };
      this.map.on('click', function (e) {
        _this3.form.longitude = e.latLng.getLng(); // 经度
        _this3.form.latitude = e.latLng.getLat(); // 纬度
        _this3.form.address = ''; // 地址
        setMarker();
        _this3.getAddressFormat();
      });
      if (this.form.longitude) {
        this.map.setCenter(new window.TMap.LatLng(this.form.latitude, this.form.longitude));
        setMarker();
      }
    },
    // 地图搜索
    searchAddress: function searchAddress() {
      var _this4 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!keyword) {
        return;
      }
      this.markerLayer.setGeometries([]);
      (0, _pos.suggestion)({
        keyword: keyword,
        region: this.form.city
      }).then(function (res) {
        if (res.code) {
          return;
        }
        var result = res.data;
        var _ref = result.data[0] || {},
          _ref$location = _ref.location,
          location = _ref$location === void 0 ? {} : _ref$location;
        var lat = location.lat,
          lng = location.lng;
        _this4.map.setCenter(new window.TMap.LatLng(lat, lng));
        _this4.searchArr = result.data;
        if (!_this4.isSearch) {
          _this4.isSearch = true;
        }
      });
    },
    setCenter: function setCenter(lat, lng) {
      this.map.setCenter(new window.TMap.LatLng(lat, lng));
    },
    getAddressFormat: function getAddressFormat() {
      var _this5 = this;
      var _this$form = this.form,
        longitude = _this$form.longitude,
        latitude = _this$form.latitude;
      (0, _pos.transition)({
        location: latitude + ',' + longitude
      }).then(function (response) {
        if (response.code) {
          return;
        }
        var res = response.data;
        var _ref2 = res.result || {},
          _ref2$address = _ref2.address,
          address = _ref2$address === void 0 ? '' : _ref2$address,
          _ref2$address_compone = _ref2.address_component,
          address_component = _ref2$address_compone === void 0 ? {} : _ref2$address_compone,
          _ref2$formatted_addre = _ref2['formatted_addresses'].standard_address,
          standard_address = _ref2$formatted_addre === void 0 ? '' : _ref2$formatted_addre;
        console.log(res.result);
        _this5.form.city = address_component.city || _this5.form.city;
        _this5.form.location = address;
        _this5.form.address = standard_address;
        _this5.$emit('location', _this5.form);
      });
    },
    handleSelect: function handleSelect(res) {
      var location = res.location,
        title = res.title,
        address = res.address,
        city = res.city;
      var lat = location.lat,
        lng = location.lng;
      this.form.latitude = lat;
      this.form.longitude = lng;
      this.form.location = title;
      this.form.address = address;
      this.form.city = city || this.form.city;
      this.$emit('location', this.form);
      this.isSearch = false;
      // 点标注数据数组
      var geometries = [{
        id: 1,
        position: new window.TMap.LatLng(lat, lng)
      }];

      // 绘制地点标注
      this.markerLayer.updateGeometries(geometries);
    },
    handleChangeRegion: function handleChangeRegion() {
      var row = this.$refs.cascader.getCheckedNodes()[0];
      if (row) {
        this.form.city = row.label;
        var _row$data = row.data,
          lat = _row$data.lat,
          lng = _row$data.lng;
        this.setCenter(lat, lng);
      }
    },
    validate: function validate() {
      var that = this;
      return new Promise(function (res) {
        that.$refs.ruleForm.validate(function (valid) {
          res(valid);
        });
      });
    }
  }
};
exports.default = _default2;